import cx from 'classnames';
import PropTypes from 'prop-types';

/**
 * Icon component that renders a material symbol icon.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.name - The name of the icon to be displayed.
 * @param {boolean} [props.bold] - Optional flag to render the icon in bold style.
 * @param {string} [props.className] - Optional additional class names to apply to the icon.
 * @returns {JSX.Element} The rendered icon component.
 */
const Icon = (props) => {
  const { name, bold = false, className } = props;

  const classes = cx('icon material-symbols-rounded', { bold }, className);

  return <span className={classes}>{name}</span>;
};

export default Icon;

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  bold: PropTypes.bool,
  className: PropTypes.string,
};
